
import React, { createContext, useContext, useState } from 'react';



const CartContext = createContext();


export const CartProvider = ({ children }) => {
  const [totalPrice, setTotalPrice] = useState(
    localStorage.getItem('cartTotalValue') == null 
      ? 0 
      : parseFloat(localStorage.getItem('cartTotalValue'))
  );

  const [itemQuantities, setItemQuantities] = useState(
    localStorage.getItem('cartQuantityValue') == null 
      ? {} 
      : JSON.parse(localStorage.getItem('cartQuantityValue'))
  );
  

  
  const updateTotalPrice = (priceChange) => {
     const numericChange = parseFloat(priceChange);
    //  console.log(numericChange);
     if (!isNaN(numericChange)) {
      setTotalPrice((prevTotal) => prevTotal + numericChange);
    } else {
      console.error('Invalid numeric value:', priceChange);
    }
  };

  const resetTotalPrice = () => {
    setTotalPrice(0);
  };

  const updateQuantity = (_id, newQuantity, price, offerPrice) => {
    // console.log(newQuantity);
    
    const finalPrice = offerPrice || price; 
  
    setItemQuantities((prevQuantities) => ({
      ...prevQuantities,
      [_id]: { quantity: newQuantity, price: finalPrice } 
    }));
  
    let total = 0;
    const cartItems = { ...itemQuantities, [_id]: { quantity: newQuantity, price: finalPrice } };
  
    Object.keys(cartItems).forEach((element) => {
      total += cartItems[element]?.quantity * parseFloat(cartItems[element]?.price);
    });
  
    setTotalPrice(total.toFixed(2));
    localStorage.setItem("cartQuantityValue", JSON.stringify(cartItems));
    localStorage.setItem("cartTotalValue", total.toFixed(2));
  };
  


  return (
    <CartContext.Provider 
  value={{ totalPrice, setTotalPrice, updateTotalPrice, resetTotalPrice, itemQuantities, setItemQuantities, updateQuantity }}>
  {children}
</CartContext.Provider>

  );
};


export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
};
